/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-named-as-default */
/* eslint-disable react/prop-types */
/* eslint-disable import/no-unresolved */
import React from 'react';
import classNames from 'classnames';

// components
import { Grid, Radio } from '@design-system-coopeuch/web';
import SimpleCard from '../../molecules/SimpleCard/SimpleCard';
// styles
import { WrapperRadio } from '../../../assets/styles/styles';
// assets
import iconQRAppCoopeuchAppStoreGooglePlay from '../../../assets/img/icon-qr-appcoopeuch-appstore-googleplay.png';
// import iconQRAppCoopeuchAppStore from '../../../assets/img/icon-qr-appcoopeuch-appstore.png';
import iconQRAppCoopeuchGooglePlay from '../../../assets/img/icon-qr-appcoopeuch-googleplay.svg';
import iconQRAppCoopeuchAppGallery from '../../../assets/img/icon-qr-appcoopeuch-appgallery.svg';
import iconQRPassCoopeuchAppStore from '../../../assets/img/icon-qr-passcoopeuch-appstore.png';
import iconQRPassCoopeuchGooglePlay from '../../../assets/img/icon-qr-passcoopeuch-googleplay.png';
import iconQRPassCoopeuchAppGallery from '../../../assets/img/icon-qr-passcoopeuch-appgallery.png';
import iconLogoAppstore from '../../../assets/img/icon-logo-appstore.png';
import iconLogoGoogleplay from '../../../assets/img/icon-logo-googleplay.png';
import iconLogoAppgallery from '../../../assets/img/icon-logo-appgallery.png';

const ContentAppPassCoopeuch = (props) => {
  const { nameCurrentModal, storeSelected, onChangeStoreSelected } = props;

  const qrsAppPassCoopeuch = {
    appCoopeuch: {
      appStore: iconQRAppCoopeuchAppStoreGooglePlay,
      googlePlay: iconQRAppCoopeuchGooglePlay,
      appGallery: iconQRAppCoopeuchAppGallery,
    },
    passCoopeuch: {
      appStore: iconQRPassCoopeuchAppStore,
      googlePlay: iconQRPassCoopeuchGooglePlay,
      appGallery: iconQRPassCoopeuchAppGallery,
    },
  };

  return (
    <SimpleCard
      contentHeader={
        <article className="d-flex flex-column">
          <p className="font-size-18 line--height-24 font-weight-bold pr-4">
            Selecciona tu tienda de aplicaciones y escanea el código con tu celular.
          </p>
        </article>
      }
    >
      <Grid row className="py-5 px-4 m-0">
        <Grid col={12} md={4} className="p-0 px-2">
          <SimpleCard
            className={classNames(
              'simplecard-digitize',
              `${storeSelected === 'appStore' ? 'simplecard-header-lightblue-background' : ''}`
            )}
            withoutShadow
            contentHeader={
              <WrapperRadio>
                <Radio
                  name="appStore"
                  label="Appstore"
                  checked={storeSelected === 'appStore'}
                  onChange={() => onChangeStoreSelected('appStore')}
                />
              </WrapperRadio>
            }
          >
            <Grid className="p-0 d-flex flex-column">
              <Grid className="p-4 pt-6 d-flex flex-column justify-content-start align-items-center">
                <img src={iconLogoAppstore} alt="" width="80" />
                <p className="mt-2 text-center">Iphone y Ipad</p>
              </Grid>
              <Grid className="p-0 py-4 d-flex justify-content-center align-items-center border-top border-neutral-alfa-15">
                <img
                  className={storeSelected !== 'appStore' ? 'opacity-1' : ''}
                  src={qrsAppPassCoopeuch[nameCurrentModal].appStore}
                  alt=""
                  width="120"
                />
              </Grid>
            </Grid>
          </SimpleCard>
        </Grid>
        <Grid col={12} md={4} className="p-0 px-2">
          <SimpleCard
            className={classNames(
              'simplecard-digitize',
              `${storeSelected === 'googlePlay' ? 'simplecard-header-lightblue-background' : ''}`
            )}
            withoutShadow
            contentHeader={
              <WrapperRadio>
                <Radio
                  name="googlePlay"
                  label="Googleplay"
                  checked={storeSelected === 'googlePlay'}
                  onChange={() => onChangeStoreSelected('googlePlay')}
                />
              </WrapperRadio>
            }
          >
            <Grid className="p-0 d-flex flex-column">
              <Grid className="p-4 pt-6 d-flex flex-column justify-content-start align-items-center">
                <img src={iconLogoGoogleplay} alt="" width="80" />
                <p className="mt-2 text-center">Samsung, Xiaomi, Motorola, Vivo, etc.</p>
              </Grid>
              <Grid className="p-0 py-4 d-flex justify-content-center align-items-center border-top border-neutral-alfa-15">
                <img
                  className={storeSelected !== 'googlePlay' ? 'opacity-1' : ''}
                  src={qrsAppPassCoopeuch[nameCurrentModal].googlePlay}
                  alt=""
                  width="120"
                />
              </Grid>
            </Grid>
          </SimpleCard>
        </Grid>
        <Grid col={12} md={4} className="p-0 px-2">
          <SimpleCard
            className={classNames(
              'simplecard-digitize',
              `${storeSelected === 'appGallery' ? 'simplecard-header-lightblue-background' : ''}`
            )}
            withoutShadow
            contentHeader={
              <WrapperRadio>
                <Radio
                  name="appGallery"
                  label="AppGallery"
                  checked={storeSelected === 'appGallery'}
                  onChange={() => onChangeStoreSelected('appGallery')}
                />
              </WrapperRadio>
            }
          >
            <Grid className="p-0 d-flex flex-column">
              <Grid className="p-4 pt-6 d-flex flex-column justify-content-start align-items-center">
                <img src={iconLogoAppgallery} alt="" width="80" />
                <p className="mt-2 text-center">Huawei</p>
              </Grid>
              <Grid className="p-0 py-4 d-flex justify-content-center align-items-center border-top border-neutral-alfa-15">
                <img
                  className={storeSelected !== 'appGallery' ? 'opacity-1' : ''}
                  src={qrsAppPassCoopeuch[nameCurrentModal].appGallery}
                  alt=""
                  width="120"
                />
              </Grid>
            </Grid>
          </SimpleCard>
        </Grid>
      </Grid>
    </SimpleCard>
  );
};

export default ContentAppPassCoopeuch;
